import { render, staticRenderFns } from "./PopupParcel.vue?vue&type=template&id=430c710a&scoped=true&"
import script from "./PopupParcel.vue?vue&type=script&lang=ts&"
export * from "./PopupParcel.vue?vue&type=script&lang=ts&"
import style0 from "./PopupParcel.vue?vue&type=style&index=0&id=430c710a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430c710a",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
